export default __webpack_public_path__ + "images/7db7ae69d7d188078984326018aa0907-football.jpg";